export default {
  customTooltipWrapper: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)',
    display: 'block',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    minWidth: '170px',
  },
  customTooltip: {
    margin: '8px 16px',
    fontSize: '14px',
    lineHeight: '1.5',
    color: '#2c3e50',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  customTooltipKey: {
    fontWeight: '600',
    color: '#1a202c',
    marginRight: '8px',
  },
  customTooltipValue: {
    fontWeight: '400',
    color: '#4a5568',
    textAlign: 'right',
  },
  customTooltipDate: {
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '16px',
    color: '#1a202c',
    marginBottom: '8px',
    paddingBottom: '8px',
    borderBottom: '2px solid #f7fafc',
    letterSpacing: '0.025em',
  },
};
